import type { TFunction } from "@/hooks/useTranslation"
import type { IssueDescriptionKaiProps } from "../.."

export const getSubtitle = (props: IssueDescriptionKaiProps, t: TFunction) => {
  const { irrelevantItems, positiveItems, undeterminedItems } = props
  const falseAndConfirmed =
    irrelevantItems.length > 0 && positiveItems.length > 0
  const isUndetermined = undeterminedItems.length > 0

  if (falseAndConfirmed && isUndetermined) return t("all_subTitle")

  if (falseAndConfirmed) return t("both", { count: positiveItems.length })

  if (irrelevantItems.length > 0 && isUndetermined)
    return t("falsePositive_undetermined_subTitle", {
      count: undeterminedItems.length
    })

  if (positiveItems.length > 0 && isUndetermined)
    return t("confirmed_undetermined_subTitle")

  if (isUndetermined) return t("undetermined_subTitle")

  return null
}

export const getTitle = (props: IssueDescriptionKaiProps, t: TFunction) => {
  if (props.analyzing)
    return { title: t("analyzing"), subTitle: t("analyzingSubTitle") }

  const {
    irrelevantItems: irrelevant,
    positiveItems: positive,
    undeterminedItems: undetermined
  } = props

  if (irrelevant.length > 0)
    return {
      title: t("falsePositive", { count: irrelevant.length }),
      subTitle: getSubtitle(props, t)
    }

  if (positive.length > 0) {
    if (undetermined.length > 0)
      return {
        title: `${t("confirmed", { count: positive.length })}, ${t("confirmed_undetermined", { count: undetermined.length })}`,
        subTitle: getSubtitle(props, t)
      }

    return {
      title: t("confirmed", { count: positive.length }),
      subTitle: null
    }
  }

  if (undetermined.length > 0)
    return {
      title: t("undetermined", { count: undetermined.length }),
      subTitle: getSubtitle(props, t)
    }

  return { title: null, subTitle: null }
}
